import React, { useContext } from "react";
import { ToastContext } from "../../../../utilities/contexts/ToastContext";
import { translate } from "../../../../utilities/Translate";
import sourceOneRestRequest from "../../../../utilities/requests/SourceOneRestRequest";
import "./ECLButton.css";

export default function ECLActionButton({ block }) {
   const addToast = useContext(ToastContext);
   async function handleClick() {
      const payload = {
         query_type: "run_document_process_action",
         process_actions: block.data.process_actions,
      };

      sourceOneRestRequest(payload)
         .then(() => {
            addToast("Action Completed Successfully");
         })
         .catch((e) => {
            addToast("Action Error");
            console.error(e);
         });
   }
   return (
      <div>
         <button className="ECLActionButton" onClick={handleClick}>
            {translate(block.data.button_text)}
         </button>
      </div>
   );
}
